import {
  ApolloError,
  OperationVariables,
  QueryResult,
  useLazyQuery,
} from '@apollo/client'
import { IFeaturedContinueEnrollment } from '@utils/featuredContinueLessons'
import { GET_FEATURED_CONTINUE_LESSONS } from './queries/getFeaturedContinueLessons'

interface IUseGetFeaturedContinueLessonsData {
  enrollment: IFeaturedContinueEnrollment | null
}

export const useGetFeaturedContinueLessons = () => {
  const [getFeaturedContinueLessons, { loading, error }] = useLazyQuery(
    GET_FEATURED_CONTINUE_LESSONS,
    { fetchPolicy: 'cache-and-network' },
  )

  return { getFeaturedContinueLessons, loading, error } as {
    getFeaturedContinueLessons: (options: {
      variables: { id: string; courseId: string; limit: number }
    }) => Promise<
      QueryResult<IUseGetFeaturedContinueLessonsData, OperationVariables>
    >
    loading: boolean
    error: ApolloError | undefined
  }
}
